import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AddImageObject, ChangeImageObject, Image } from "./media.interface";

@Injectable({ providedIn: "root" })
export class ImagesService {
  constructor(private http: HttpClient) {}

  getImages = (): Observable<Image[]> => {
    return this.http.get<Image[]>("/media/images");
  };

  removeImage = (imageId: string): Observable<unknown> => {
    return this.http.delete(`/media/images/${imageId}`);
  };

  addImage = (payload: AddImageObject): Observable<Image> => {
    const formData = new FormData();
    formData.append("image", payload.file);
    formData.append("name", payload.name);

    return this.http.post<Image>("/media/images", formData);
  };

  changeImage = (image: ChangeImageObject): Observable<ChangeImageObject> => {
    return this.http
      .put(`/media/images/${image.imageId}`, { name: image.name })
      .pipe(map(() => image));
  };
}
